export default "__VITE_ASSET__7ea57cda__"